import { NavLink } from 'react-router-dom';

const tabClass =
  'rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-slate-100 hover:text-slate-900';

function Tab({ to, end, children }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `${tabClass} ${isActive ? 'bg-blue-50 text-blue-700' : 'text-slate-600'}`
      }
    >
      {children}
    </NavLink>
  );
}

export function DashboardTabs() {
  return (
    <nav
      className="flex flex-wrap gap-1 border-b border-slate-200 bg-white px-4 py-2"
      aria-label="Dashboard sections"
    >
      <Tab to="/dashboard" end>Overview</Tab>
      <Tab to="/dashboard/receivables">Receivables</Tab>
      <Tab to="/dashboard/payables">Payables</Tab>
      <span className="mx-1 hidden self-center border-l border-slate-200 py-2 sm:block" />
      <Tab to="/mis">MIS Report</Tab>
      <Tab to="/kpis">KPIs</Tab>
      <Tab to="/unit-economics">Unit Econ</Tab>
      <Tab to="/cash-forecast">Cash Forecast</Tab>
      <Tab to="/inventory">Inventory</Tab>
      <Tab to="/finance-calendar">Calendar</Tab>
    </nav>
  );
}
